module.exports = __webpack_public_path__ + "img/電気回路_3_2_3.f7d6d824.png";